module.exports = __webpack_public_path__ + "img/bank-assert-rules.aba269e2.svg";